import DatePicker from 'antd/lib/date-picker'
import 'antd/lib/date-picker/style/index.css'

export default DatePicker



// WEBPACK FOOTER //
// ./src/elements/date-picker/index.js